export default {
  facet: {
    date: {
      custom: "Dates personnalisées"
    }
  }
}
